/*eslint no-useless-escape: "off"*/
const embed = (name, props) => {
    const indent = name.length + 13;
    const propString = Object.keys(props).map(key => `${key}="${props[key]}"`).join("\n" + " ".repeat(indent));
    return `<html>
<head>
    <script src="https://widgets.webimpact.ch/${name}-widget.min.js"><\/script>
</head>
<body>
    <${name}-widget ${propString}>
    </${name}-widget>
</body>
</html>`
};

const embedLib = (name, props) => {
    const indent = name.length + 13;
    const propString = Object.keys(props).map(key => `${key}="${props[key]}"`).join("\n" + " ".repeat(indent));
    return `<html>
<head>
    <script src="https://unpkg.com/vue@latest"><\/script>
</head>
<body>
    <${name}-widget ${propString}>
    </${name}-widget>
    <script src="https://widgets.webimpact.ch/widget.loader.js" widget-name="${name}-widget"><\/script>
</body>
</html>`;
};

const iframe = (name, props, width) => {
    const indent = name.length + 13;
    const propString = Object.keys(props).map(key => `${key}="${props[key]}"`).join("\n" + " ".repeat(indent));
    const html = `<html>
<head>
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />
    <script src="https://widgets.webimpact.ch/${name}-widget.min.js"><\/script>
    <style>
        body {
            background: #ffffff;
            font-family: Roboto, sans-serif;
        }
        input, select, textarea {
            font-family: Roboto;
        }
        ${name}-widget, [${name}-widget] {
            margin: 20px auto;
            display: block;
            max-width: ${width || 950}px;
        }
    </style>
</head>
<body>
    <${name}-widget ${propString}>
    </${name}-widget>
</body>
</html>`

    return `data:text/html;charset=utf-8,${escape(html)}`
};

const iframeLib = (name, props, width) => {
    const indent = name.length + 13;
    const propString = Object.keys(props).map(key => `${key}="${props[key]}"`).join("\n" + " ".repeat(indent));
    const html = `<html>
<head>
    <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />
    <style>
        body {
            background: #ffffff;
            font-family: Roboto, sans-serif;
        }
        input, select, textarea {
            font-family: Roboto;
        }
        ${name}-widget, [${name}-widget] {
            margin: 20px auto;
            display: block;
            max-width: ${width || 950}px;
        }
    </style>
    <script src="https://unpkg.com/vue@latest"><\/script>
</head>
<body>
        <${name}-widget ${propString}>
        </${name}-widget>
        <script src="https://widgets.webimpact.ch/widget.loader.js" widget-name="${name}-widget"><\/script>
</body>
</html>`

    return `data:text/html;charset=utf-8,${escape(html)}`
};

export { embed, iframe, embedLib, iframeLib };